"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencyFormatter = void 0;
const currencyFormatter = (currency, value, simplify, raw = false) => {
    const has_decimal_places = value % 1 !== 0;
    switch (currency) {
        case "JPY":
            if (raw) {
                return `¥${value}`;
            }
            if (simplify) {
                return `¥ ${value.toLocaleString("en-US", {
                    notation: "compact",
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                })}`;
            }
            return `¥ ${value.toLocaleString("en-US", {
                maximumFractionDigits: 0,
                minimumFractionDigits: 0,
            })}`;
        case "THB":
            if (raw) {
                return `฿${value.toLocaleString("en-US", {
                    maximumFractionDigits: has_decimal_places ? 2 : 0,
                    minimumFractionDigits: has_decimal_places ? 2 : 0,
                })}`;
            }
            return `฿${value.toLocaleString("en-US", {
                maximumFractionDigits: 0,
                minimumFractionDigits: 0,
            })}`;
        case "AED":
            if (raw) {
                return `AED ${value}`;
            }
            return `AED ${value.toLocaleString("en-US", {
                maximumFractionDigits: has_decimal_places ? 2 : 0,
                minimumFractionDigits: has_decimal_places ? 2 : 0,
            })}`;
        case "SGD":
            if (raw) {
                return `$${value} SGD`;
            }
            return `$${value.toLocaleString("en-US", {
                maximumFractionDigits: has_decimal_places ? 2 : 0,
                minimumFractionDigits: has_decimal_places ? 2 : 0,
            })} SGD`;
        case "MYR":
            if (raw) {
                return `RM ${value}`;
            }
            return `RM ${value.toLocaleString("en-US", {
                maximumFractionDigits: has_decimal_places ? 2 : 0,
                minimumFractionDigits: has_decimal_places ? 2 : 0,
            })}`;
        case "USD":
            if (raw) {
                return `$${value} USD`;
            }
            return `$${value.toLocaleString("en-US", {
                maximumFractionDigits: has_decimal_places ? 2 : 0,
                minimumFractionDigits: has_decimal_places ? 2 : 0,
            })} USD`;
        case "IDR":
            if (raw) {
                return `Rp ${value}`;
            }
            if (simplify) {
                return `Rp ${value.toLocaleString("en-US", {
                    notation: "compact",
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                })}`;
            }
            return `Rp ${value.toLocaleString("en-US", {
                maximumFractionDigits: 0,
                minimumFractionDigits: 0,
            })}`;
        case "CNY":
            if (raw) {
                return `¥${value}`;
            }
            return `¥ ${value.toLocaleString("en-US", {
                maximumFractionDigits: has_decimal_places ? 2 : 0,
                minimumFractionDigits: has_decimal_places ? 2 : 0,
            })}`;
        case "AUD":
            if (raw) {
                return `$${value} AUD`;
            }
            return `$${value.toLocaleString("en-US", {
                maximumFractionDigits: has_decimal_places ? 2 : 0,
                minimumFractionDigits: has_decimal_places ? 2 : 0,
            })} AUD`;
        case "CAD":
            if (raw) {
                return `$${value} CAD`;
            }
            return `$${value.toLocaleString("en-US", {
                maximumFractionDigits: has_decimal_places ? 2 : 0,
                minimumFractionDigits: has_decimal_places ? 2 : 0,
            })} CAD`;
        case "EUR":
            if (raw) {
                return `€${value}`;
            }
            return `€${value.toLocaleString("en-US", {
                maximumFractionDigits: has_decimal_places ? 2 : 0,
                minimumFractionDigits: has_decimal_places ? 2 : 0,
                currency: "EUR",
            })}`;
        case "HKD":
            if (raw) {
                return `$${value} HKD`;
            }
            return `$${value.toLocaleString("en-US", {
                maximumFractionDigits: has_decimal_places ? 2 : 0,
                minimumFractionDigits: has_decimal_places ? 2 : 0,
            })} HKD`;
        case "INR":
            if (raw) {
                return `₹ ${value}`;
            }
            return `₹ ${value.toLocaleString("en-US", {
                maximumFractionDigits: 0,
                minimumFractionDigits: 0,
            })}`;
        case "SAR":
            if (raw) {
                return `SAR ${value}`;
            }
            return `SAR ${value.toLocaleString("en-US", {
                maximumFractionDigits: has_decimal_places ? 2 : 0,
                minimumFractionDigits: has_decimal_places ? 2 : 0,
            })}`;
        case "NZD":
            if (raw) {
                return `$${value} NZD`;
            }
            return `$${value.toLocaleString("en-US", {
                maximumFractionDigits: has_decimal_places ? 2 : 0,
                minimumFractionDigits: has_decimal_places ? 2 : 0,
            })} NZD`;
        case "DKK":
            if (raw) {
                return `kr. ${value}`;
            }
            return `kr. ${value.toLocaleString("en-US", {
                maximumFractionDigits: has_decimal_places ? 2 : 0,
                minimumFractionDigits: has_decimal_places ? 2 : 0,
            })}`;
        case "PHP":
            if (raw) {
                return `₱ ${value}`;
            }
            return `₱ ${value.toLocaleString("en-US", {
                maximumFractionDigits: has_decimal_places ? 2 : 0,
                minimumFractionDigits: has_decimal_places ? 2 : 0,
            })}`;
        case "NOK":
            if (raw) {
                return `kr ${value}`;
            }
            return `kr ${value.toLocaleString("en-US", {
                maximumFractionDigits: has_decimal_places ? 2 : 0,
                minimumFractionDigits: has_decimal_places ? 2 : 0,
            })}`;
        case "ZAR":
            if (raw) {
                return `R ${value}`;
            }
            return `R ${value.toLocaleString("en-US", {
                maximumFractionDigits: has_decimal_places ? 2 : 0,
                minimumFractionDigits: has_decimal_places ? 2 : 0,
            })}`;
        case "SEK":
            if (raw) {
                return `${value} kr`;
            }
            return `${value.toLocaleString("en-US", {
                maximumFractionDigits: has_decimal_places ? 2 : 0,
                minimumFractionDigits: has_decimal_places ? 2 : 0,
            })} kr`;
        case "TWD":
            if (raw) {
                return `$${value} TWD`;
            }
            return `$${value.toLocaleString("en-US", {
                maximumFractionDigits: 0,
                minimumFractionDigits: 0,
            })} TWD`;
        case "GBP":
            if (raw) {
                return `£${value}`;
            }
            return `£${value.toLocaleString("en-US", {
                maximumFractionDigits: has_decimal_places ? 2 : 0,
                minimumFractionDigits: has_decimal_places ? 2 : 0,
            })}`;
        case "KRW":
            if (raw) {
                return `₩${value}`;
            }
            return `₩${value.toLocaleString("en-US", {
                maximumFractionDigits: 0,
                minimumFractionDigits: 0,
            })}`;
        case "CHF":
            if (raw) {
                return `${value} CHF`;
            }
            return `${value.toLocaleString("en-US", {
                maximumFractionDigits: has_decimal_places ? 2 : 0,
                minimumFractionDigits: has_decimal_places ? 2 : 0,
            })} CHF`;
        case "VND":
            if (raw) {
                return `VND ${value}`;
            }
            // return value as million eg. 1.19M if simplify
            if (simplify) {
                return `VND ${value.toLocaleString("en-US", {
                    notation: "compact",
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                })}`;
            }
            return `VND ${value.toLocaleString("en-US", {
                maximumFractionDigits: 0,
                minimumFractionDigits: 0,
            })}`;
    }
};
exports.currencyFormatter = currencyFormatter;
